import { render } from "./vision.vue?vue&type=template&id=7d4b2bf7&scoped=true"
const script = {}

import "./vision.vue?vue&type=style&index=0&id=7d4b2bf7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4b2bf7"]])

export default __exports__